module.exports = __webpack_public_path__ + "img/map-and-contact-black-mazda.2b672fb2.png";